










import Vue, { PropOptions } from 'vue'
import { Specification } from '~/models/classified/types'
import { mapGetters, mapState } from 'vuex'
export default Vue.extend({
  components: {
    ParkedSpecificationValueAdmin: () =>
      import('./ParkedSpecificationValueAdmin')
  },
  props: {
    specification: {
      type: Object,
      required: true
    } as PropOptions<Specification>
  },
  computed: {
    ...mapGetters({
      userIsAdmin: 'user/isAdmin'
    }),
    ...mapState({
      classifiedId: state => state.classifieds.view.classified.id
    })
  }
})
